module.exports = "/_next/static/images/316e46f056e785e9380e1679d5737096-woman-using-cellphone@2x.jpg.webp";